import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import AuthorizationTypeService from "@services/AuthorizationTypeService";
import PermissionHandler from "@hoc/cruds/PermissionHandler";

const ShowAuthorizationType = ({ authorizationType }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [authorizationTypeData, setAuthorizationTypeData] = useState([]);
  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      AuthorizationTypeService.find(authorizationType.id).then((response) => {
        setAuthorizationTypeData(response.data.data);
      });
  }, [authorizationType.id, showModal]);

  return (
    <PermissionHandler permission={"view_authorization_types"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={authorizationTypeData.name} />
          <RowDetails
            label={t("nameEng")}
            value={authorizationTypeData.name_eng}
          />
          <RowDetails
            label={t("description")}
            value={authorizationTypeData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowAuthorizationType;
